<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">

			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;">
					<h4 style="font-weight: bold; margin-bottom: 10px">{{$store.state.lang.text.account_info[$store.state.lang.language]}}</h4>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="name">{{$store.state.lang.text.fullname[$store.state.lang.language]}}</label>
							<input id="name" type="text" v-model="user.name" :placeholder="$store.state.lang.text.fullname[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="username">{{$store.state.lang.text.username[$store.state.lang.language]}}</label>
							<input id="username" type="text" disabled="disabled" v-model="user.username" :placeholder="$store.state.lang.text.username[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="phone">{{$store.state.lang.text.phone[$store.state.lang.language]}}</label>
							<input id="phone" type="text" v-model="user.phone" :placeholder="$store.state.lang.text.phone[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">{{$store.state.lang.text.balance[$store.state.lang.language]}}</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-medium-size-33 md-size-33">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="account_name">{{$store.state.lang.text.bank_name[$store.state.lang.language]}}</label>
						 <select v-model="select" style="    width: 100%;
						 background: var(--secondary-color);
						 border: none;
						 color: var(--white);
						 border: 1px solid var(--secondary-color);
						 border-radius: 10px;
						 margin-bottom: 15px;
						 padding: 12px 10px 13px;">
							  <option value="">{{$store.state.lang.text.choose_bank[$store.state.lang.language]}}</option>
							  <option v-for="method in method_withdraw" :value="method.id">{{method.type}}</option>
						 </select>
						</div>
					</form>
				</div>

			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-33" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="account_name">{{$store.state.lang.text.bank_account_name[$store.state.lang.language]}}</label>
							<input id="account_name" type="text" pattern="[A-Za-z]" v-model="user.account_name" :placeholder="$store.state.lang.text.bank_account_name[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-33" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>

						<div class="form__grp">
							<label for="account_number">{{$store.state.lang.text.bank_number[$store.state.lang.language]}}</label>
							<input id="account_number" type="number" v-model="user.account_number" :placeholder="$store.state.lang.text.bank_number[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="form__tabs__wrap">
					<form>
						<div class="create__btn"><a class="cmn--btn" @click="updateUser()" style="margin-top: 5px"><span>{{$store.state.lang.text.save_info[$store.state.lang.language]}}</span></a></div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;padding: 15px">
					<span style="font-size: 15px; font-weight: bold;">{{$store.state.lang.text.referral[$store.state.lang.language]}}</span>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="referral">{{$store.state.lang.text.referral_info[$store.state.lang.language]}}</label>
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-70 md-small-size-70 md-medium-size-70 md-size-80" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<!-- <label for="referral">{{$store.state.lang.text.referral_info[$store.state.lang.language]}}</label> -->
							<input id="referral" type="text" disabled="disabled" :value="config.referral+user.hash" ref="referral_link" :placeholder="$store.state.lang.text.referral[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-30 md-small-size-30 md-medium-size-30 md-size-20" style="margin-bottom: 18px">
				<div class="tooltip">
					<button @click="copyReferral()" style="background-color: #135F87;
					border: 0px;
					border-radius: 10px;
					padding: 12px 18px;
					width: 100%;
					color: #FFF;
					font-family: 'Poppins', 'Koh Santepheap', sans-serif;">
					  <span class="tooltiptext" ref="myTooltip" v-if="!copied">{{$store.state.lang.text.copy[$store.state.lang.language]}}</span>
					  <span class="tooltiptext" ref="myTooltip" v-if="copied">{{$store.state.lang.text.copied[$store.state.lang.language]}}</span>
					  </button>
					</div>
			</div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.getUser();
			this.getPayment();
		},
		methods: {
			getUser() {
				this.$http.get(this.config.api + "/user/authed/user/get_data").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.user = res.body.data
						this.select = res.body.data.bank_type_id != null ? res.body.data.bank_type_id : ""
					}
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/user/authed/payment/get_data").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.method_withdraw = res.body.data.method_withdraw;
					}
				})
			},
			updateUser() {

				if(String(this.select).length > 0 && this.user.name.length > 0 && String(this.user.phone).length >0 && this.user.account_number.length > 0 && this.user.account_name.length > 0) {
					this.$store.state.authentication.loading = true;
					this.$http.post(this.config.api + "/user/authed/user/update", {
						name: this.user.name,
						phone: this.user.phone,
						type: this.getBankType(this.select),
						type_id: this.select,
						account_name: this.user.account_name,
						account_number: this.user.account_number
					}).then(res => {
						this.$store.state.authentication.loading = false;
						if (res.body.status == 'success') {
							this.$notification.notify(this.$store.state.lang.text.update_info_success[this.$store.state.lang.language]);
							this.getUser();
						}
					})
				} else {
					this.$notification.notify(this.$store.state.lang.text.pleaseFill[this.$store.state.lang.language]);
				}

			},
			copyReferral() {
				let copyText = this.$refs.referral_link;
				console.log(copyText);
				copyText.select();
				copyText.setSelectionRange(0, 99999);

				this.copied = true;
				navigator.clipboard.writeText(copyText.value);
			},
			getBankType(id) {
				for(let i = 0; i <this.method_withdraw.length; i++) {
					if(this.method_withdraw[i].id == id) return this.method_withdraw[i].type
				}
			}
		},
		computed: {
		},
		data() {
			return {
				select: "",
				copied: false,
				user: {
					hash: "",
					username: "",
					name: "",
					phone: "",
					balance: 0,
					bank_type: "",
					bank_type_id: "",
					account_number: "",
					account_name: ""
				},
				method_withdraw: [],
				loaded: false
			}
		}
	}
</script>
<style>
	.account-list-menu {
		cursor:pointer; background-color: #103037; border-radius: 15px;padding: 15px; margin-bottom: 15px
	}
	.account-list-menu:nth-child(odd) {
		min-width: calc(30% - 15px) !important;
		max-width: calc(30% - 15px) !important;
		margin-right: 15px !important;
	}
	@media (max-width: 1264px) {
		.account-list-menu:nth-child(odd) {
			min-width: calc(40% - 15px) !important;
			max-width: calc(40% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (max-width: 944px) {
		.account-list-menu:nth-child(odd) {
			min-width: calc(50% - 15px) !important;
			max-width: calc(50% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	.account-active {
		background-color: #20283F;
	}

</style>



// WEBPACK FOOTER //
// src/pages/Account/Account.vue